module.exports = __webpack_public_path__ + "static/media/10.5952ba53.jpg";